import loadCustomerModule from './modules/Customer.module';
import loadSessionModule from './modules/Session.module';
const loadAccountDeliveryAddressesRootModule = () => ({
    hasRouter: false,
    modules: [loadCustomerModule(), loadSessionModule()],
});
export default loadAccountDeliveryAddressesRootModule;
